import {Injectable} from '@angular/core';
import {cloneDeep} from 'lodash-es';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {EmptyWidgetSettings, EmptyWidgetSettingsDef} from './empty-widget-settings';

@Injectable()
export class EmptyWidgetSettingsService implements WidgetSettingsService {

    private defaultSettingsDef: EmptyWidgetSettingsDef = {
        title: null
    };

    public getDefaultSettings(): Observable<EmptyWidgetSettings> {
        return this.fromDefinition(this.defaultSettingsDef);
    }

    public fromDefinition(settingsDef: EmptyWidgetSettingsDef): Observable<EmptyWidgetSettings> {
        return of<EmptyWidgetSettings>({
            title:                    null,
            origWidgetTypeId:         settingsDef.origWidgetTypeId || this.defaultSettingsDef.origWidgetTypeId,
            origWidgetSettings:       settingsDef.origWidgetSettings
                                          || cloneDeep(this.defaultSettingsDef.origWidgetSettings),
            origWidgetLinkingGroupId: settingsDef.origWidgetLinkingGroupId
        });
    }

    public toDefinition(settings: EmptyWidgetSettings): EmptyWidgetSettingsDef {
        return settings && {
            title:                    null,
            origWidgetTypeId:         settings.origWidgetTypeId || this.defaultSettingsDef.origWidgetTypeId,
            origWidgetSettings:       settings.origWidgetSettings
                                          || cloneDeep(this.defaultSettingsDef.origWidgetSettings),
            origWidgetLinkingGroupId: settings.origWidgetLinkingGroupId
        };
    }

}
